export default "__VITE_ASSET__B87x4NGj__"